var _text, _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2d2d2d",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#333333",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    }
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 60,
    fontFamily: "Georgia, serif",
    fontSize: 42,
    fontWeight: 300,
    textAnchor: "middle",
    fill: "url(#textGradient)",
    letterSpacing: "2px"
  }, "\n    pixxelmind\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 70,
    x2: 120,
    y2: 70,
    stroke: "#333333",
    strokeWidth: 1,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 70,
    x2: 320,
    y2: 70,
    stroke: "#333333",
    strokeWidth: 1,
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 1.5,
    fill: "#666666",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 70,
    r: 1,
    fill: "#666666",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 70,
    r: 1.5,
    fill: "#666666",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 70,
    r: 1,
    fill: "#666666",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 70,
    r: 1,
    fill: "#666666",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 70,
    r: 1.5,
    fill: "#666666",
    opacity: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 70,
    r: 1,
    fill: "#666666",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 70,
    r: 1.5,
    fill: "#666666",
    opacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 40,
    width: 2,
    height: 2,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 42,
    width: 1,
    height: 1,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 42,
    width: 1,
    height: 1,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 40,
    width: 2,
    height: 2,
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33f1ae46209d39fbf7a06d255e02bc3c.svg";
export { ForwardRef as ReactComponent };